import styled from 'styled-components';

export const Text = styled.p`
  text-align: center;
  font-size: 26px;
`;
